import IchiBalanceContainer from 'containers/IchiBalanceContainer';
import React from 'react';
import Bottombar from '../common/components/Bottombar/Bottombar';
import WalletContainer from 'common/components/Web3ModalContainer/WalletContainer';

const BottomBarContainer: React.FC = () => {
  return (
    <Bottombar>
      <IchiBalanceContainer isOnBottom={true} />
      <WalletContainer isOnBottom={true} />
    </Bottombar>
  );
};

export default BottomBarContainer;
